import React, { useState } from 'react';
import t from 'react-translate';
import { NvPillTab, BadgeColor } from 'shared/components/nv-pill-tab';
import { LearnerProgressSavedView } from 'redux/schemas/models/learner-progress-saved-view';
import { NvDropdownOption } from 'shared/components/inputs/nv-dropdown';

type SavedViewPillProps = {
  view: LearnerProgressSavedView;
  isSelected: boolean;
  onClick: () => void;
  onEditFilters: () => void;
  onDelete: () => void;
  tabId: string;
};

const SavedViewPill = ({ view, isSelected, onClick, onEditFilters, onDelete, tabId }: SavedViewPillProps) => {
  const [isConfirmingDelete, setIsConfirmingDelete] = useState(false);

  const menuItems: NvDropdownOption[] = [
    {
      type: 'text',
      text: t.LEARNER_PROGRESS.TABS.MENU_EDIT_FILTERS(),
      callback: onEditFilters,
      dataQa: 'LEARNER_PROGRESS_SAVED_VIEW_EDIT_FILTERS',
    },
    { type: 'divider' },
    {
      type: 'text',
      text: t.LEARNER_PROGRESS.TABS.MENU_DELETE(),
      class: 'text-danger',
      callback: () => {
        setIsConfirmingDelete(true);
      },
      dataQa: 'LEARNER_PROGRESS_SAVED_VIEW_DELETE',
    },
  ];

  const assignmentsName = view?.assignments?.map((a) => a?.title)?.join(', ');
  return (
    <NvPillTab
      label={view.viewName}
      count={view.learnersCount ?? 0}
      isSelected={isSelected}
      onClick={onClick}
      id={tabId}
      dataQA={`LEARNER_PROGRESS_SAVED_VIEW_PILL_${view?.viewCode?.toUpperCase()}`}
      badgeColor={BadgeColor.DANGER}
      menuItems={menuItems}
      confirmationPopover={{
        show: isConfirmingDelete,
        header: t.LEARNER_PROGRESS.TABS.DELETE_CONFIRM_HEADER(),
        cancelText: t.LEARNER_PROGRESS.TABS.DELETE_CONFIRM_CANCEL(),
        confirmText: t.LEARNER_PROGRESS.TABS.DELETE_CONFIRM_YES(),
        onCancel: () => setIsConfirmingDelete(false),
        onConfirm: () => {
          setIsConfirmingDelete(false);
          onDelete();
        },
      }}
      hoverContent={(
        <div className='hover-content'>
          <div className='mb-1'><strong>{view.viewName}:</strong></div>
          {view?.filters?.inactiveFor && <div>{t.LEARNER_PROGRESS.TABS.INACTIVE_HOVER_DESCRIPTION()} <strong>{t.LEARNER_PROGRESS.TABS.INACTIVE_HOVER_DAYS(String(view.filters.inactiveFor))}</strong></div>}
          {assignmentsName && <div>{t.LEARNER_PROGRESS.FILTERS.HAS_NOT_COMPLETED()} <strong>{assignmentsName}</strong></div>}
          {view?.filters?.minPoints && <div>{t.LEARNER_PROGRESS.TABS.EARNED_FEWER_THAN()} <strong>{t.LEARNER_PROGRESS.TABS.EARNED_FEWER_THAN_SUFFIX(String(view.filters.minPoints))}</strong></div>}
        </div>
      )}
    />
  );
};

export default SavedViewPill;
